var map = {
	"./__tests__/handleLtiPostMessage.test.js": [
		"meBD",
		670
	],
	"./__tests__/lti.resourceImported.test.js": [
		"TgQ9",
		654
	],
	"./__tests__/requestFullWindowLaunch.test.js": [
		"kzID",
		655
	],
	"./handleLtiPostMessage.js": [
		"vBsS"
	],
	"./lti.resourceImported.js": [
		"WrIf",
		671
	],
	"./messageTypes.js": [
		"bj3y"
	],
	"./requestFullWindowLaunch.js": [
		"vC4c",
		672
	],
	"./toggleCourseNavigationMenu.js": [
		"cHZI",
		253,
		673
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "JrkR";
module.exports = webpackAsyncContext;